const Layout = () => import('@/layout/index.vue')

export default {
    path: '/commission',
    component: Layout,
    redirect: '/commission/index',
    name: 'Commission',
    meta: {
        title: '佣金流水',
        icon: 'commission'
    },
    children: [
        {
            path: 'index',
            name: 'CommissionIndex',
            component: () => import('@/views/commission/index.vue'),
            meta: {
                title: '佣金流水',
                sidebar: false,
                breadcrumb: false,
                activeMenu: '/commission',
                auth: ['commission']
            }
        }
    ]
}
